import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastService } from './toast-service.service';

@Injectable({
  providedIn: 'root',
})
export class AlertService {

  constructor(private toastService: ToastService) { }


  public showNotificationForHttpError(error: HttpErrorResponse): void {
    if (error.status === 422) {
      this.toastService.showError(error.error.message, 'Validation Error')
      return;
    }
    if (error.status === 403) {
      this.toastService.showError(error.error.message, 'Request Error')
      return;
    }
    if (error.status === 401) {
      this.toastService.showError(error.error.message, 'Request Error')
      return;
    }

    if (error.status === 500) {
      this.toastService.showError('An error occurred at the server. Please, refresh the page and try again or contact support for assistance.', 'Server Error')
      return;
    }

    this.toastService.showError('An error occurred. Please, refresh the page and try again or contact support for assistance.', 'Error')
    return;
  }

  private playSound(name = "tone-1.mp3") {
    let audio = new Audio();
    // Root-relative: `<base href="/">` + path routing means a `../../../` prefix is resolved
    // by the BROWSER against the current URL, so it 404s on routes 5 segments deep
    // (e.g. /provider/claims/benefit-bookings/index/all-benefit-bookings). Fixed 2026-08-07.
    audio.src = "/assets/sounds/" + name;
    audio.load();
    audio.play();
  }

  playSoundNotification() {
    this.playSound();
  }
}
